import seo from '@/core/data/landingSeo.json'

const L = seo.locales.ja

export default {
  landing: {
    title: L.title,
  },
  home: {
    title: L.title,
  },
  upload: {
    title: "画像アップロード",
  },
  login: {
    title: "ログイン",
  },
  result: {
    title: "画像分析",
  },
  confirm: {
    title: "メール確認完了",
  },
  terms: {
    title: "利用規約",
  },
  privacy: {
    title: "プライバシーポリシー",
  },
  blog: {
    title: "写真編集ガイドと概念 | PhotoScope ブログ",
    subtitle: "参考画像を使って写真編集を学ぼう。トーン、色、スタイルの違いに関する実践的なガイドで、初心者が意図を持って編集できるよう支援します。",
  },
  history: {
    title: "履歴",
  },
  about: {
    title: "会社概要 - PhotoScope",
  },
  payment: {
    success: "支払い完了",
    cancel: "支払いキャンセル",
  },
  dashboard: {
    title: "ダッシュボード",
  },
};
